"use strict";
import { useEffect, useState } from "react";
const DEVTOOLS_BUTTON_SELECTOR = ".tsqd-open-btn-container";
const canDevtoolsMount = () => process.env.NODE_ENV !== "production" && typeof document !== "undefined";
const hasDevtoolsButton = () => {
  if (!canDevtoolsMount()) return false;
  return document.querySelector(DEVTOOLS_BUTTON_SELECTOR) !== null;
};
export const useHasQueryDevtoolsButton = () => {
  const [isPresent, setIsPresent] = useState(hasDevtoolsButton);
  useEffect(() => {
    if (!canDevtoolsMount()) return;
    const observer = new MutationObserver(() => setIsPresent(hasDevtoolsButton()));
    observer.observe(document.body, { childList: true, subtree: true });
    setIsPresent(hasDevtoolsButton());
    return () => observer.disconnect();
  }, []);
  return isPresent;
};
